export const API_URL = import.meta.env.VITE_BACKEND_URL as string;
export const FASTAPI_URL = import.meta.env.VITE_RAG_API as string;

/** Origin of the V3 marketing dashboard opened in an iframe on /marketing. */
export const MARKETING_DASHBOARD_ORIGIN = import.meta.env
  .VITE_MARKETING_DASHBOARD_ORIGIN as string;
